namespace $.$$ {

	$mol_style_define( $shm_tree, {

		flex: {
			direction: 'column',
		},

		Row: {
			position: 'relative',
			alignItems: 'stretch',
			minHeight: '2.5rem',
			width: '100%',
		},

		Guides: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			width: 0,
			pointerEvents: 'none',

		},

		Guide: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			width: '1px',
			background: { color: $mol_theme.line },
		},

		Toggle: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			width: '1.5rem',
			minWidth: '1.5rem',
			maxWidth: '1.5rem',
			minHeight: 0,
			padding: 0,
			alignItems: 'center',
			justifyContent: 'center',
		},

		Content: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
			width: '100%',
		},

	} )

}
